import React, { useEffect, useState } from "react";
import './help-and-support.scss'
import { Button, Col, Drawer, Row, Spin, Typography } from "antd";
import objectIcon from "../../assets/images/help-support-object.svg";
import chatIcon from "../../assets/images/help-support-chat.svg";
import FAQcomponent from "./components/faqs-component";
import InvoiceComponent from "./components/invoice-component";
import ViewAllComplaints from "./components/view-all-complaints";
import TrainingVideo from "./components/training-video";
import WriteToUs from "./components/write-to-us";
import NodataImg from "../../assets/images/nodata-img.svg";
import { useTranslation } from "react-i18next";
import { GetComplaints, getFAQ } from "../../service/helpAndSupport/helpAndSupportService";
import { useStore } from "../../store/store";
import moment from "moment";


const { Text } = Typography;
const HelpAndSupport = () => {
  const { t } = useTranslation();
  const { user } = useStore();
  const [showAll, setShowAll] = useState(false);
  const [complaintsData, setComplaintsData] = useState([
  ])
  const [openWriteToUsModel, setOpenWriteToUsModel] = useState(false)
  const [selectedItem, setSelectedItem] = useState('FAQs');
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [faqData, setFaqData] = useState([]);
  const [loading, setLoading] = useState(false)
  const [pageRefresh , setPageRefresh] = useState(false);

  useEffect(() => {

    
      fetchComplaints();

      fetchFAQ();

  }, [pageRefresh]);
  const payload = {
    type: "Ongoing",
    supplierId: user?.userId,
    complaintId: "",
    status: "Open",
    fromRaisedDate: new Date('2025-04-01').toISOString().split('T')[0],
    toRaisedDate: new Date().toISOString().split('T')[0],
    pageNumber: 1,
    pageSize: 10,
  };

  const fetchComplaints = async () => {
    try {
      setLoading(true);
      const response = await GetComplaints(payload);

      setComplaintsData(response?.data?.data);
    } catch (err) {
      setLoading(false);
      console.log('Failed to load complaints. Please try again later.');
    } finally {
      setLoading(false);
    }
  };
  const fetchFAQ = async () => {
    try {
      const languageCode = user?.selectedLanguage || 'en';
      const response = await getFAQ(languageCode);

      setFaqData(response?.data?.data);
    } catch (error) {
      console.error('Error fetching FAQs:', error);
    }
  };


  const handleClick = (item) => {
    setSelectedItem(item);
  };
  const handleViewAll = () => {
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };
  const redirectToSupportEmail = () => {
    const userName = user?.userName;
    const userCountry = user?.operatingCountry;
    const email = "support.partner@trukker.com";
    const subject = `Need Help | ${userName} | ${userCountry}`;

    const gmailLink = `https://mail.google.com/mail/?view=cm&to=${email}&su=${encodeURIComponent(subject)}`;
    window.open(gmailLink, "_blank");
  };
  return (
    <div className="help-and-support-wrapper">
      <Row className="need-help-card-wrapper">
        <Row className="need-help-card-body">
          <div className="help-card-div">
            <Col span={10} className="write-to-us-button-card">
              <span className="need-help-caption">{t("NEED_HELP_ISSUE")}</span>
              <span className="instant-help-caption">{t("NEED_HELP_CUSTOMER_SUPPORT")}</span>
              {/* <span><Button className="chat-button" onClick={redirectToSupportEmail}><img src={chatIcon} alt="icon" />{t("NEED_HELP_WRITE_TO_US")}</Button></span> */}
               <span><Button className="chat-button" onClick={()=>setOpenWriteToUsModel(true)}><img src={chatIcon} alt="icon" />{t("NEED_HELP_WRITE_TO_US")}</Button></span>

            </Col>
            <Col span={10}></Col>
            <Col span={4}>
              <img src={objectIcon} alt="Icon" />
            </Col>
          </div>
        </Row>

      </Row>

      <Row className="ongoing-complains-wrapper">
        <div className="ongoing-complaints-title">{t("NEED_HELP_COMPLAINTS")} <span className="view-all-btn" onClick={handleViewAll}>
          {showAll ? t('NEED_HELP_VIEW_LESS') : t('NEED_HELP_VIEW_ALL')}
        </span></div>
        {loading ? <Spin style={{ marginLeft: "50%" }}></Spin> : <div className="complaints-card-div-wrapper">
          {complaintsData.length > 0 && complaintsData?.slice(0, showAll ? complaintsData.length : 3).map((item, index) => {
            return (
              <div key={index} className="complaints-card">
                <Row className="complainID-card">{t("NEED_HELP_COMPLAIN_ID")}: {item?.complaintId}</Row>
                <Row className="complaints-first-row">
                  <span className="invoice-col">
                    {item?.orderNumber ? <span className="raised-on">{t("NEED_HELP_ORDER_ID")}: {item?.orderNumber ? item?.orderNumber : "NA"}</span> : <span className="raised-on">  {t("NEED_HELP_DONOT_FIND_ORDER")}</span>}
                    <span className="raised-on">{t("NEED_HELP_RAISED_ON")}:{moment.utc(item?.raisedDate ? item?.raisedDate : "NA").format("DD/MM/YYYY")}</span>
                  </span>
                  <span className="statusKey-wrapper">{item?.resolutionStatus}</span>
                </Row>
                <Row className="complaints-description">
                  <span className="description">{t("NEED_HELP_CATEGORY")}</span>
                  <span className="description-message">  {item?.category !== null ? item?.category : "NA"}</span>
                </Row>
                <Row className="complaints-description">
                  <span className="description">{t("NEED_HELP_COMPLAINTS_DESCRIPTION")}</span>
                  <Text style={{width:"320px"}} ellipsis={{tooltip:true}} className="description-message">{item?.remarks !== null ? item?.remarks : "NA"}</Text>
                </Row>

              </div>
            )
          })}
        </div>}
      </Row>
      <Row className="FAQ-invoice-complaints-video-row-wrapper">
        <Col span={8} className="left-side-sidebar-wrapper">
          <div className="left-sidebar-container">
            <span
              className={`sidebar-input ${selectedItem === 'FAQs' ? 'selected' : ''}`}
              onClick={() => handleClick('FAQs')}
            >
              <span className="sidebar-value">{t("NEED_HELP_FAQS")}</span>
              <span className="sidebar-desc">{t("NEED_HELP_QUERIES_ANSWERED")}</span>
            </span>

            <span
              className={`sidebar-input ${selectedItem === 'Invoice' ? 'selected' : ''}`}
              onClick={() => handleClick('Invoice')}
            >
              <span className="sidebar-value">{t("NEED_HELP_RAISE_ISSUE")}</span>
              <span className="sidebar-desc">{t("NEED_HELP_REPORT_PROBLEM")}</span>
            </span>

            <span
              className={`sidebar-input ${selectedItem === 'Complaints' ? 'selected' : ''}`}
              onClick={() => handleClick('Complaints')}
            >
              <span className="sidebar-value">{t("NEED_HELP_VIEW_ALL_COMPLAINTS")}</span>
              <span className="sidebar-desc">{t("NEED_HELP_TRACK_COMPLAINTS")}</span>
            </span>

            <span
              className={`sidebar-input ${selectedItem === 'Training' ? 'selected' : ''}`}
              onClick={() => handleClick('Training')}
            >
              <span className="sidebar-value">{t("NEED_HELP_TRAINING_VIDEOS")}</span>
              <span className="sidebar-desc">{t("NEED_HELP_LEARN_WITH_TRAINING_VIDEO")}</span>
            </span>
          </div>
        </Col>
        <Col span={16} className="right-side-wrapper">
          {loading ? (
            <div><Spin style={{ marginLeft: "50%", marginTop: "10%" }}></Spin></div>
          ) : (
            selectedItem === 'FAQs' && <FAQcomponent faqData={faqData} />
          )}
          {selectedItem === 'Invoice' && <InvoiceComponent setPageRefresh={setPageRefresh} pageRefresh={pageRefresh} />}
          {selectedItem === 'Complaints' && <ViewAllComplaints />}
          {selectedItem === 'Training' && <TrainingVideo />}
        </Col>
      </Row>
      {openWriteToUsModel && <WriteToUs setOpenWriteToUsModel={setOpenWriteToUsModel} modalTitle={t("NEED_HELP_WRITE_TO_US")} modalDescription=" " />}
      <Drawer
        title={t("NEED_HELP_ALL_COMPLAINTS")}
        placement="right"
        width={600}
        onClose={closeDrawer}
        visible={drawerVisible}
      >
        <div className="complaints-card-div-wrapper-drawer">
          {complaintsData.length > 0 ?
            complaintsData?.map((item, index) => {
              return (
                <div key={index} className="complaints-card-drawer">
                  <Row className="complainID-card">{t("NEED_HELP_COMPLAIN_ID")}: {item?.complaintId}</Row>
                  <Row className="complaints-first-row">
                    <span className="invoice-col">
                      {item?.orderNumber ? <span className="raised-on">{t("NEED_HELP_ORDER_ID")}: {item?.orderNumber ? item?.orderNumber : "NA"}</span> : <span className="raised-on">  {t("NEED_HELP_DONOT_FIND_ORDER")}</span>}
                      <span className="raised-on">{t("NEED_HELP_RAISED_ON")}:{moment.utc(item?.raisedDate).format("DD/MM/YYYY")}</span>
                    </span>
                    <span className="statusKey-wrapper">{item?.resolutionStatus}</span>
                  </Row>
                  <Row className="complaints-description">
                    <span className="description">{t("NEED_HELP_CATEGORY")}</span>
                    <span className="description-message">  {item?.category !== null ? item?.category : "NA"}</span>
                  </Row>
                  <Row className="complaints-description">
                    <span className="description">{t("NEED_HELP_COMPLAINTS_DESCRIPTION")}</span>
                    <span className="description-message">{item?.remarks !== null ? item?.remarks : "NA"}</span>
                  </Row>
                </div>
              );
            }) : <Row justify={'center'} style={{ height: '60vh' }}>
              <img src={NodataImg} alt='no data' />
            </Row>

          }
        </div>
      </Drawer>
    </div>

  )
}

export default HelpAndSupport;